module.exports = __webpack_public_path__ + "img/icon7.6c9cf6e8.svg";